import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { of, Observable } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import * as BusquedaNissAllActions from '../../actions';
import { BusquedaNissService } from 'src/app/services/SicarMap/BusquedaNiss.service';
import { DatosNiss } from 'src/app/models/SicarMap/DatosNiss.model';

@Injectable()
export class busquedaNissEffects {

    constructor(
        private actions$: Actions,
        private BusquedaService: BusquedaNissService
    ) {}

    @Effect()
    GetDataNissAction: Observable<Action> = this.actions$.pipe(
        ofType(BusquedaNissAllActions.GET_DATA_NISS),
        switchMap((action: BusquedaNissAllActions.GetDataNissAction) => {
            return this.BusquedaService.getDatosNiss(action.Niss)
                .pipe(
                    map((Datos: DatosNiss) => {
                        return new BusquedaNissAllActions.GetDataNissSuccesAction(Datos);
                    }),
                    catchError(error => of (new BusquedaNissAllActions.GetDataNissFailureAction({ error })))
                );
            })
      );
}
